import React from 'react';
import { withRouter } from "react-router";

function Header() {
  return (
    <header className="header scrolled">
      <div className="header__container">
        <a className="logo" href="https://linforsakring.se"></a>
        <div className="header__nav">
          <div className="menu-toggle hamburger hamburger--squeeze">
            <span className="hamburger-box">
              <span className="hamburger-inner"></span>
            </span>
          </div>
          <nav className="header__navigation">
            <ul className="header__navigation-menu">
              <li className="active menu-item menu-hem header__navigation-menu-item">
                <a href="https://linforsakring.se/" className="active menu-item menu-hem header__navigation-menu-item-child" >Hem</a>
              </li>

              <li className="menu-item menu-vara-forsakringar header__navigation-menu-item">
                <a href="https://linforsakring.se/vara-forsakringar/" className="menu-item menu-vara-forsakringar header__navigation-menu-item-child" >Våra försäkringar</a>
              </li>

              <li className="menu-item menu-om-lin header__navigation-menu-item">
                <a href="https://linforsakring.se/om-lin/" className="menu-item menu-om-lin header__navigation-menu-item-child" >Om Lin</a>
              </li>

              <li className="menu-item menu-kontakta-oss header__navigation-menu-item">
                <a href="https://linforsakring.se/kontakt/" className="menu-item menu-kontakta-oss header__navigation-menu-item-child" >Kontakta oss</a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
}

export default withRouter(Header);
